import React from "react";
import { Bot, AppWindow, ArrowRight } from "lucide-react";

interface ManualWorkflowTriggerProps {
  onContinueInChat: () => void;
  onSwitchToManual: () => void;
}

const ManualWorkflowTrigger: React.FC<ManualWorkflowTriggerProps> = ({
  onContinueInChat,
  onSwitchToManual,
}) => {
  return (
    <div className="flex flex-col items-center justify-center w-full my-6 px-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="bg-white dark:bg-slate-800/90 backdrop-blur-md border border-slate-200 dark:border-slate-700/60 rounded-2xl p-6 shadow-xl shadow-blue-900/5 max-w-2xl w-full text-center relative overflow-hidden">
        {/* Decorative background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-blue-50/50 to-transparent dark:from-blue-900/20 pointer-events-none" />

        <div className="relative z-10">
          <div className="flex justify-center mb-4">
            <div className="relative">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg transform rotate-3 transition-transform hover:rotate-6">
                <AppWindow className="text-white w-8 h-8" />
              </div>
              <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-slate-100 dark:bg-slate-700 rounded-full flex items-center justify-center border-2 border-white dark:border-slate-800 shadow-sm">
                <Bot className="text-blue-600 dark:text-blue-400 w-4 h-4" />
              </div>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-2">
            Accelerate your Recruitment Workflow
          </h3>
          <p className="text-slate-500 dark:text-slate-400 mb-8 max-w-lg mx-auto">
            Switch to the Manual Workflow Dashboard for a UI-first experience. Easily search resumes, schedule interviews, and manage offers with dedicated tools, or continue chatting directly with the agent.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={onSwitchToManual}
              className="flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white font-medium rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
            >
              <AppWindow className="w-5 h-5" />
              Switch to Manual Workflow
            </button>
            <button
              onClick={onContinueInChat}
              className="flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-3 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-medium rounded-xl border border-slate-200 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700 hover:border-slate-300 dark:hover:border-slate-500 transition-all duration-200"
            >
              <Bot className="w-5 h-5" />
              Continue in Chat
              <ArrowRight className="w-4 h-4 ml-1 opacity-70" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualWorkflowTrigger;
